import { createBrowserRouter } from 'react-router-dom';
import App from '../App.jsx';
import RootPage from '../pages/RootPage.jsx';
import LoginPage from '../pages/LoginPage/LoginPage.jsx';

const routes = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    children: [{ path: 'root', element: <RootPage /> }],
  },
  {
    path: '/login',
    element: <LoginPage />,
  },
]);

export default routes;
